import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'

import { formatDecimalDynamic } from 'utils/masks'
import applyMask from 'component/report/utils/Formatter'
import columns from './columns'
import resize from 'images/h-resize.svg'
import ResizableDiv from 'component/ResizableDiv'

class Table extends Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    handleResize: PropTypes.func.isRequired,
    records: PropTypes.array.isRequired,
    sideFilterElement: PropTypes.object,
    sideFilterVisible: PropTypes.bool.isRequired,
    topMargin: PropTypes.number.isRequired,
    translate: PropTypes.func.isRequired,
  }

  componentDidUpdate() {
    this.handleLeft()
  }

  handleLeft = () => {
    const { records, sideFilterElement, sideFilterVisible } = this.props

    const columnsToRender = columns.filter(
      (column) => column.fixed && column.render
    )

    columnsToRender.forEach((column, index) => {
      const node = ReactDOM.findDOMNode(this.refs[column.field])

      const lastNode =
        index === 0
          ? node
          : ReactDOM.findDOMNode(this.refs[columnsToRender[index - 1].field])

      const left =
        index === 0 || !lastNode
          ? `${sideFilterVisible ? sideFilterElement.clientWidth : 0}px`
          : `${
              lastNode.clientWidth +
              Number(lastNode.style.left.replace('px', ''))
            }px`

      if (node) node.style.left = left

      for (let i = 0; i < records.length; i++) {
        const domNode = ReactDOM.findDOMNode(this.refs[`${column.field}${i}`])

        if (domNode) domNode.style.left = left
      }
    })

    columns
      .filter((column) => !column.fixed && column.render)
      .map((column) => {
        const left = 'auto'

        const domNode = ReactDOM.findDOMNode(this.refs[column.field])

        if (domNode) domNode.style.left = left

        for (let i = 0; i < records.length; i++) {
          const domNode2 = ReactDOM.findDOMNode(
            this.refs[`${column.field}${i}`]
          )

          if (domNode2) domNode2.style.left = left
        }
      })
  }

  renderHeader = () => {
    const { topMargin, translate } = this.props

    const renderColumns = columns

    return renderColumns.reduce(
      (acc, { className, field, fixed, headerLabel, render }) => {
        if (render) {
          return [
            ...acc,
            <th
              className={fixed ? 'sticky-column' : 'scroll-column'}
              key={`${headerLabel}.${field}`}
              ref={field}
              style={{ top: `${topMargin}px` }}
            >
              <ResizableDiv
                axis='x'
                className={`cell ${className}`}
                handle={
                  <div className='resize-handle'>
                    <img src={resize} />
                  </div>
                }
                height={45}
                key={field}
                onResizeStop={this.handleLeft}
                width={200}
              >
                <div className='header'>{translate(headerLabel)}</div>
              </ResizableDiv>
            </th>,
          ]
        }

        return [...acc]
      },
      []
    )
  }

  formatDecimalDynamic = (field, numHouses, translate) => {
    if (field || field === 0) {
      return formatDecimalDynamic(field, numHouses, translate)
    }
  }

  renderBody = () => {
    const { handleResize, records, translate } = this.props

    handleResize()

    return records.map((row, i) => (
      <tr key={i}>
        {columns.reduce(
          (acc, { className, field, fixed, headerLabel, render, type }) => {
            if (render) {
              if (type === 'decimal2') {
                return [
                  ...acc,
                  <td
                    className={`${fixed ? 'sticky' : 'scroll'}-column`}
                    key={field}
                    ref={`${field}${i}`}
                  >
                    <div className={className}>
                      {this.formatDecimalDynamic(
                        row[field],
                        row.numHouses,
                        translate
                      )}
                    </div>
                  </td>,
                ]
              }
              return [
                ...acc,
                <td
                  className={`${fixed ? 'sticky' : 'scroll'}-column`}
                  key={field}
                  ref={`${field}${i}`}
                >
                  <div className={className}>
                    {applyMask(type, row[field], translate, headerLabel)}
                  </div>
                </td>,
              ]
            }

            return [...acc]
          },
          []
        )}
      </tr>
    ))
  }

  render() {
    return (
      <table className='table-adjustment'>
        <thead>
          <tr>{this.renderHeader()}</tr>
        </thead>
        <tbody>{this.renderBody()}</tbody>
      </table>
    )
  }
}

export default Table
